<script lang="ts">
  import InlineSVG from 'svelte-inline-svg';
  import illustration404 from '../../assets/404.svg';

  export let title: string = '404 – Not found!';
</script>

<style lang="postcss">
  .container {
    display: grid;
    align-items: center;
    width: 100%;
    margin: auto;
    padding: 0 2rem;
    text-align: center;
  }

  @media (min-width: 640px) {
    .container {
      grid-template-columns: 1fr 1fr;
    }
  }

  .text {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0;
    color: var(--ubilabs-yellow);
    font-size: 2rem;
    font-weight: 700;
  }

  @media (min-width: 640px) {
    .text {
      font-size: 3rem;
    }
  }

  @media (min-width: 1024px) {
    .text {
      font-size: 4rem;
    }
  }

  .illustration404 > :global(svg) {
    width: 100%;
    height: 100%;
    max-height: calc(100vh - 11rem);
  }
</style>

<div class="container">
  <h1 class="text">{title}</h1>
  <div class="illustration404"><InlineSVG src={illustration404} /></div>
</div>
